import { render, staticRenderFns } from "./New-Lease.vue?vue&type=template&id=7a7c84c6&"
import script from "./New-Lease.vue?vue&type=script&lang=ts&"
export * from "./New-Lease.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports